import React, { useContext } from "react";
import { ReactComponent as CartIcon } from "../../icons/cartIcon.svg";
//import { Field, Form, Formik, ErrorMessage } from "formik";
//import * as Yup from "yup";
import { CartContext } from "../../contexts/CartContext";

const OrderSummary = () => {
  const { cart, shippingCost, taxRate } = useContext(CartContext); // Get cart from context
  /*
  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    console.log(values);
    setSubmitting(false);
  };
  */

  const calculateSubtotal = () => {
    return cart.reduce((total, item) => total + item.price * item.amount, 0);
  };

  const getFirstSentence = (description) => {
    const firstSentence = description.split(".")[0];
    return firstSentence ? firstSentence + "." : description;
  };

  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const taxes = subtotal * taxRate;
    return subtotal + taxes + shippingCost;
  };

  return (
    <div className="bg-[#f5f5f5] h-full border-l border-pearlGray flex justify-center ">
      <div className="max-w-lg px-10 lg:sticky h-full">
        <header className="flex items-center justify-center gap-14 ">
          <div className="w-6 h-6"></div>
          <div className="flex-1 flex justify-center">
            <div style={{ aspectRatio: "2/1" }} className="w-48">
              {/* <img src={logoImg} alt="logoImg" /> */}
            </div>
          </div>

          <div className="w-6 h-6">
            <CartIcon />
          </div>
        </header>
        <aside>
          <div>
            {cart.map((item) => (
              <div key={item.id} className="mb-8 flex flex-wrap items-center">
                <div
                  style={{ borderWidth: "1px" }}
                  className="px-2 rounded border-lightGray w-16 h-16 relative"
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="object-cover w-full h-full"
                  />

                  <div className="absolute right-0 top-0 translate-x-1/4 -translate-y-2/4 w-6 h-6">
                    <div className="bg-dimGray rounded-full text-[#f5f5f5] flex justify-center items-center">
                      {item.amount}
                    </div>
                  </div>
                </div>

                <div className="pl-5 flex-1">
                  <p className="text-sm">{item.title}</p>
                  <p className="text-xs text-dimGray">
                    {getFirstSentence(item.description)}
                  </p>
                </div>
                <div className="pl-5">
                  <p className="text-sm">
                    ${(item.price * item.amount).toFixed(2)}
                  </p>
                </div>
              </div>
            ))}
            {/* TODO When we add Coupons
            <div className="mb-8">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <div className="flex gap-4">
                      <div className="flex-1">
                        <Field
                          id="email"
                          type="email"
                          name="email"
                          placeholder="Discount code or gift card"
                          className="block w-full px-3 py-3 border border-pearlGray rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
                        />
                      </div>

                      <button
                        type="submit"
                        disabled={isSubmitting}
                        style={{ borderWidth: "1px" }}
                        className="bg-paleSilver border-pearlGray text-dimGray font-medium py-2 px-4 rounded"
                      >
                        Apply
                      </button>
                    </div>

                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-red-500 text-xs mt-1"
                    />
                  </Form>
                )}
              </Formik>
            </div> */}
            <div className="mb-8">
              <div className="mb-2 flex justify-between gap-2">
                <span className="text-sm">Subtotal</span>
                <span className="font-medium text-sm">
                  ${calculateSubtotal().toFixed(2)}
                </span>
              </div>
              <div className="mb-2 flex justify-between gap-2">
                <span className="text-sm">Shipping Cost</span>
                <span className="font-medium text-sm">
                  ${shippingCost.toFixed(2)}
                </span>
              </div>
              <div className="mb-2 flex justify-between gap-2">
                <span className="text-sm">Estimated taxes</span>
                <span className="font-medium text-sm">
                  ${(calculateSubtotal() * taxRate).toFixed(2)}
                </span>
              </div>
              <div className="flex justify-between gap-2">
                <span className="text-lg font-medium">Total</span>
                <span className="text-sm">
                  USD
                  <span className="text-lg font-medium pl-2">
                    ${calculateTotal().toFixed(2)}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default OrderSummary;
